"use client"

import { createContext, useContext, useState, useCallback, type ReactNode } from "react"

interface MobileNavContextValue {
    isOpen: boolean
    open: () => void
    close: () => void
    toggle: () => void
}

const MobileNavContext = createContext<MobileNavContextValue | null>(null)

export function MobileNavProvider({ children }: { children: ReactNode }) {
    const [isOpen, setIsOpen] = useState(false)

    const open = useCallback(() => setIsOpen(true), [])
    const close = useCallback(() => setIsOpen(false), [])
    const toggle = useCallback(() => setIsOpen((prev) => !prev), [])

    return <MobileNavContext.Provider value={{ isOpen, open, close, toggle }}>{children}</MobileNavContext.Provider>
}

export function useMobileNav() {
    const context = useContext(MobileNavContext)
    if (!context) {
        throw new Error("useMobileNav must be used within MobileNavProvider")
    }
    return context
}
